import styles from "../css/Header.module.css";
import pdlogo from "../../../icons/fanduNewLogo.svg";
import fp from "../../../icons/coin.svg";
import { useNavigate } from "react-router-dom";

function Header({ fanduPoints, avail }) {
  const navigate = useNavigate();

  return (
    <div className={styles.headerCustom}>
      <div>
        <h3 className={styles.heading}>
          <div className={` d-flex justify-content-center align-items-center`}>
            <div>
              <img
                src={pdlogo}
                alt="pdlogo"
                style={{ width: "60px" }}
                onClick={() => navigate("/fandu-offers")}
              />
            </div>
          </div>
        </h3>
      </div>
      <div
        className={styles.fanduPoints}
        onClick={async () => {
          if (typeof avail === "function") {
            await avail(
              "Header_Fandu_Points",
              "Header",
              "Click",
              "Screen_Impressions",
            );
          }

          navigate("/rewards");
        }}
      >
        <img src={fp} style={{ width: "18px" }} />
        <h6
          style={{
            marginTop: "8px",
            fontSize: "12px",
            color: "#fff",
            fontWeight: "700",
          }}
        >
          {fanduPoints}
        </h6>
      </div>
    </div>
  );
}

export default Header;
